import { ConfigSnapshot } from "../../../../src/data/extended-api/00-interest/config-snapshot";
import { ConfigTier } from "../../../../src/data/extended-api/00-interest/config-tier";
import * as React from 'react';
export default {
  ConfigSnapshot,
  ConfigTier,
  React
};